interface CopyTextEnvironment {
  document: Document;
  navigator: Navigator;
}

/**
 * Copy to the clipboard with a legacy fallback. Some browsers expose the Clipboard API
 * but reject writeText outside an explicit permission grant, so a bare
 * `navigator.clipboard.writeText` silently fails for a slice of real users.
 */
export const copyText = async (
  text: string,
  environment: CopyTextEnvironment = { document, navigator },
): Promise<void> => {
  if (environment.navigator.clipboard?.writeText) {
    try {
      await environment.navigator.clipboard.writeText(text);
      return;
    } catch (_error) {
      // Fall through to the legacy copy path so the action still works when possible.
    }
  }

  const textArea = environment.document.createElement('textarea');
  textArea.value = text;
  textArea.setAttribute('readonly', '');
  textArea.style.position = 'fixed';
  textArea.style.opacity = '0';
  environment.document.body.appendChild(textArea);
  textArea.select();

  const copied = environment.document.execCommand('copy');
  environment.document.body.removeChild(textArea);
  if (!copied) throw new Error('Clipboard copy was rejected');
};
